import { LoadingTextIndicator } from '@web/components/LoadingTextIndicator/LoadingTextIndicator';

import { useTypingObserver } from './conversationTypingNotifier.hooks';
import { Wrapper } from './conversationTypingNotifier.styles';

export const ConversationTypingNotifier = () => {
  const label = useTypingObserver();

  return label ? (
    <Wrapper>
      <LoadingTextIndicator label={label} />
    </Wrapper>
  ) : null;
};
